export default {"src":"/_next/static/media/b1.d34ec636.svg","height":65,"width":159,"blurWidth":0,"blurHeight":0};